import React from 'react'
import styled from 'styled-components/macro'

/*
 * Tabela moderna — substituta direta de @alobato/table (mesma API:
 * TableContainer, Table, TableHeaderRow, TableHeaderCell, TableRow, TableCell).
 *
 * Usa display:table nos divs: mantém o alinhamento automático de colunas sem
 * as regras de aninhamento do <table> (evita warnings do React com a marcação
 * atual, que lista header e linhas como irmãos).
 */

const stripProps = Tag => ({ width, lineHeight, ...rest }) => <Tag {...rest} />

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e8edf4;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 16px rgba(16, 24, 40, 0.05);
`

export const Table = styled.div`
  display: table;
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
`

export const TableHeaderRow = styled.div`
  display: table-row;
  background: #f7f9fc;
`

export const TableHeaderCell = styled(stripProps('div'))`
  display: table-cell;
  padding: 13px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8a9cb5;
  white-space: nowrap;
  vertical-align: middle;
  border-bottom: 1px solid #e8edf4;
  ${props => (props.width ? `width: ${props.width}px;` : '')}
`

export const TableRow = styled.div`
  display: table-row;
  transition: background 0.12s ease;
  &:hover {
    background: #f8fbfe;
  }
`

export const TableCell = styled(stripProps('div'))`
  display: table-cell;
  padding: 14px 16px;
  font-size: 14px;
  color: #2b3a4d;
  vertical-align: middle;
  border-bottom: 1px solid #f1f4f9;
  /* cada valor em uma linha só: IDs, datas e status não quebram no meio.
     Conteúdo longo (senhas de portal, e-mails) alarga a tabela e o
     TableContainer rola horizontalmente. */
  white-space: nowrap;
  ${props => (props.width ? `width: ${props.width}px;` : '')}
  ${props => (props.lineHeight !== undefined ? `line-height: ${props.lineHeight};` : '')}
`

export default Table
